
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 23 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.49 6.314L7.83 0 0 13.683 3.598 20l7.893-13.686z","fill":"#4CAF50"}}),_c('path',{attrs:{"d":"M7.83 0l7.914 13.683h7.113L15.027 0H7.83z","fill":"#FFC107"}}),_c('path',{attrs:{"d":"M7.24 13.682L3.599 20H19.26l3.598-6.318H7.241z","fill":"#2196F3"}})])
          )
        }
      }
    